import { Colors } from "./typings/colors";

export const colors: Colors = {
  violet: {
    darker: "#4040BA",
    dark: "#5656ED",
    base: "#6161FF",
    light: "#7070FF",
    lighter: "#C0C0FF",
    lightest: "#E8E8FF"
  },
  green: {
    base: "#69C022",
    light: "#E8F6DD"
  },
  yellow: {
    base: "#F3AA07",
    light: "#FDF2DA"
  },
  blue: {
    dark: "#235EE8",
    base: "#1F69FF",
    light: "#DDE8FF"
  },
  white: {
    base: "#ffffff"
  },
  emerald: {
    darker: "#088649",
    dark: "#0E9A56",
    base: "#10AC60",
    light: "#40BD80",
    lighter: "#9DDCBE",
    lightest: "#DBF3E7"
  },
  red: {
    darker: "#A91D00",
    dark: "#BD2900",
    base: "#D32F02",
    light: "#D94C26",
    lighter: "#EFBBAD",
    lightest: "#F9E0D9"
  },
  purple: {
    base: "#9254E3",
    light: "#EFE6FB"
  },
  pink: {
    base: "#DC4276",
    light: "#FBDEE8"
  },
  teal: {
    base: "#47C1BF",
    light: "#E4F6F6"
  },
  coral: {
    base: "#ED754B",
    light: "#FDEBE4"
  },
  jade: {
    base: "#4BB952",
    light: "#E3F4E5"
  },
  gray: {
    darker: "#101721",
    dark: "#6B7785",
    base: "#9FA6B0",
    light: "#E0E0E0",
    lighter: "#EDEDED",
    lightest: "#F7F7F9",
    border: "#E6E6E6"
  }
};
